import Enterprise from '@/datatypes/enterprise';
import Customer from '@/datatypes/enterprise/billing-customer';
import BillingPrice from '@/datatypes/billing/price';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class Subscription {
  public id: string;
  public customer: Customer = new Customer({});
  public enterprise: Enterprise = new Enterprise({});
  public billingPrice: BillingPrice = new BillingPrice({});
  public customerId: string;
  public status: string;

  constructor(options) {
    this.id = options.id;
    this.customerId = options.customerId;
    this.status = options.status;
    if (options.customer) {
      this.customer = new Customer(camelcaseKeysDeep(options.customer));
    }
    if (options.enterprise) {
      this.enterprise = new Enterprise(camelcaseKeysDeep(options.enterprise));
    }
    if (options.billingPrice) {
      this.billingPrice = new BillingPrice(camelcaseKeysDeep(options.billingPrice));
    }
  }
}
